
import React, { useState, useEffect } from "react";
import { BASE_URL } from "../../../constants";
import axios from 'axios';
import 'bootstrap/dist/css/bootstrap.min.css';
//import {Row, Col, Container, Card} from 'react-bootstrap';
import { Row, Col, Container, Card, Button, InputGroup } from 'react-bootstrap';
import '../../../CommonCSS/SocietyCSS.css';


// import Select from 'react-select';

const Mand_Classwise_Sub = () => {

  const [isEditable, setIsEditable] = useState(false);
  const [dropdowns, setDropdowns] = useState({ premTypes: [], mainComp: [] });
  const [ddlAllStandards, setDdlAllStandards] = useState([]);
  const [ddlSubjects, setDdlSubjects] = useState([]);
  

  // Header State 

  const [headerData, setHeaderData] = useState({
    std_id: '',
    year1: '',
    year2: '',
  });

  const [savedfromDate, setSavedFromDate] = useState('');
  const [savedendDate, setSavedEndDate] = useState('');
  const [savedYear1, setSavedYear1] = useState('');

  // Child Table Data
  const [childRows, setChildRows] = useState([
    {
      css_id: '',
      year1: '',
      year2: '',
      std_id: '',
      sub_id: '',
      sub_type_id: '',
      sub_order: '',
      unit_oral_max: '',
      unit_write_max: '',
      unit_write_pass: '',
      unit_oral_write_combo: '',
      semester_oral_max: '',
      semester_write_max: '',
      semester_write_pass: '',
      // semester_oral_write_combo: '',
      appl_final_semester: '',
      subject_group: '',
      subject_group_name: '',
      avg_subj_grp: '',
      avg_subj_grp_name: '',
      semester_II_oral_max: '',
      semester_II_write_max: '',
      semester_II_write_pass: '',
      avg_marks_divider: '',
    }
  ]);

  const handleHeaderChange = (e) => {
    const { name, value } = e.target;
    setHeaderData(prev => ({ ...prev, [name]: value }));
  };

  const handleChildChange = (index, e) => {
    const { name, value } = e.target;
    const updatedRows = [...childRows];
    updatedRows[index][name] = value;
    setChildRows(updatedRows);
  };


  useEffect(() => {
    const fetchLists = async () => {
      try {
        const stdResult = await axios.get(`${BASE_URL}/api/ddl_all_standards`);
        setDdlAllStandards(stdResult.data);

        const subResult = await axios.get(`${BASE_URL}/api/ddl_subjects`);
        setDdlSubjects(subResult.data);

        //        console.log('premtypeRes.data =====> ', premtypeRes.data);ddl_subjects
      } catch (err) {
        console.error("Dropdown fetch error:", err);
      }
    };
    fetchLists();
  }, []);

  const addRow = () => {
    const newIndex = childRows.length + 1; // 1-based index
    const newRow = {
      parent_irn: '',
      maintId: '',
      dispOrder: newIndex, // Default to index + 1
      amount: ''
    };
    setChildRows([...childRows, newRow]);
    //setChildRows([...childRows, { parent_irn: '', maintId: '', dispOrder: '', amount: '' }]);
  };

  const removeRow = (index) => {
    const updatedRows = [...childRows];
    updatedRows.splice(index, 1);
    setChildRows(updatedRows);
  };

  const handleNew = () => {
    setIsEditable(true);
    setHeaderData({
      std_id: '',
      year1: '',
      year2: '',
    });
    setChildRows([{
      css_id: '',
      year1: '',
      year2: '',
      std_id: '',
      sub_id: '',
      sub_type_id: '',
      sub_order: '',
      unit_oral_max: '',
      unit_write_max: '',
      unit_write_pass: '',
      unit_oral_write_combo: '',
      semester_oral_max: '',
      semester_write_max: '',
      semester_write_pass: '',
      // semester_oral_write_combo: '',
      appl_final_semester: '',
      subject_group: '',
      subject_group_name: '',
      avg_subj_grp: '',
      avg_subj_grp_name: '',
      semester_II_oral_max: '',
      semester_II_write_max: '',
      semester_II_write_pass: '',
      avg_marks_divider: '',
    }]);
  };

  const handleSave = async () => {

    // if (!headerData.fromDate || !headerData.toDate) {
    //   //speakMessage('From or To Date cannot be left blank.');
    //   alert('From or To Date cannot be left blank !');
    //   return;
    // }
    // else if (headerData.fromDate > headerData.toDate) {
    //   //speakMessage('From cannot be greater than To Date.');
    //   alert('From cannot be greater than To Date !');
    //   return;
    // }
    // else if (!headerData.premiseType || headerData.premiseType === '') {
    //   //speakMessage('Please Select Premise Type');
    //   alert('Please Select Premise Type !');
    //   return;
    // }

    let lv_err_msg = '';

    for (let i = 0; i < childRows.length; i++) {
      if (!childRows[i].maintId || childRows[i].maintId === '') {
        lv_err_msg = 'Please Select Maintenance Component at Row # ' + (i + 1);
        break;
      }
      else if (!childRows[i].dispOrder || childRows[i].maintId === '0') {
        lv_err_msg = 'Please enter Display Order at Row # ' + (i + 1);
        break;


      }
      else if (!childRows[i].amount || childRows[i].amount === '0' || childRows[i].amount < 0) {
        lv_err_msg = 'Please enter Maintenance Amount greater than 0 at Row # ' + (i + 1);
        break;
      }

    }

    if (lv_err_msg) {
      alert(lv_err_msg);
      return;
    }

    let lv_dupl = 0;

    for (let i = 0; i < childRows.length; i++) {
      for (let j = i + 1; j < childRows.length; j++) {
        if (childRows[i].maintId === childRows[j].maintId) {
          lv_dupl = j;
          break;
        }
      }
      if (lv_dupl > 0) {
        break;
      }
    }

    if (lv_dupl > 0) {
      playBeep();
      alert('Duplicate Maintenance Component selected at Row # ' + (lv_dupl + 1));
      return;
    }

    // DB Validation to check if the given From/To dates, Premise Type already exists or not

    const valResp = await axios.get(`${BASE_URL}/api/validate_maint_struct`,
      { params: { p_Year1: savedYear1, p_fromDate: headerData.fromDate, p_toDate: headerData.toDate, p_PremTypeId: headerData.premiseType } });

    if (valResp.data[0].rows_count > 0) {
      playBeep();
      //speakMessage('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type');
      alert('Maintenance Structure already exists for the given Year, From, To Dates and Premise Type !');
      return;
    }

    // console.log('valResp.data ===> ', valResp.data); 
    // console.log('valResp.data[0].rows_count ===> ', valResp.data[0].rows_count); 

    const isConfirmed = window.confirm("Sure you want to Save the record ?");

    if (!isConfirmed) return;

    const structdata = {
      header: headerData,
      details: childRows,
    };

    const response = await axios.post(`${BASE_URL}/api/save_maint_struct`, structdata);

    if (response.data.message === '1') {
      //alert('Maintenance Structure saved successfully !');
      speakMessage('Maintenance Structure saved successfully. Do you like to Add more ?');
      if (window.confirm("Maintenance Structure saved successfully. Do you like to Add more ?")) {
        //headerData.premiseType = '';
        //setDropdowns.premTypes('');
        const updatedChildRows = childRows.map(row => ({
          ...row,
          amount: ''
        }));
        setChildRows(updatedChildRows);
      }
      else {
        setIsEditable(false);
        setHeaderData({
          std_id: '',
          year1: '',
          year2: '',
        });
        setChildRows([{
           css_id: '',
      year1: '',
      year2: '',
      std_id: '',
      sub_id: '',
      sub_type_id: '',
      sub_order: '',
      unit_oral_max: '',
      unit_write_max: '',
      unit_write_pass: '',
      unit_oral_write_combo: '',
      semester_oral_max: '',
      semester_write_max: '',
      semester_write_pass: '',
      // semester_oral_write_combo: '',
      appl_final_semester: '',
      subject_group: '',
      subject_group_name: '',
      avg_subj_grp: '',
      avg_subj_grp_name: '',
      semester_II_oral_max: '',
      semester_II_write_max: '',
      semester_II_write_pass: '',
      avg_marks_divider: '',
        }]);
        headerData.fromDate = savedfromDate;
        headerData.toDate = savedendDate;
      }
    }

  };

  const handleClear = () => {
    if (window.confirm("Clear all data?")) {
      handleNew();
      setIsEditable(false);
    }
  };

  const playBeep = () => {
    const audioCtx = new (window.AudioContext || window.AudioContext)();
    const oscillator = audioCtx.createOscillator();
    const gainNode = audioCtx.createGain();

    oscillator.connect(gainNode);
    gainNode.connect(audioCtx.destination);

    oscillator.type = 'square'; // Other types: sine, square, triangle, sawtooth
    oscillator.frequency.setValueAtTime(440, audioCtx.currentTime); // Frequency in Hz (440Hz = A4 note)
    gainNode.gain.setValueAtTime(0.1, audioCtx.currentTime); // Volume

    oscillator.start();
    oscillator.stop(audioCtx.currentTime + 0.2); // Play for 0.2 seconds
  };

  const speakMessage = (message) => {
    const utterance = new SpeechSynthesisUtterance(message);
    utterance.lang = 'en-US'; // or 'en-GB', 'hi-IN', etc.
    utterance.rate = 1;       // Speed: 0.1 (slow) to 10 (fast)
    utterance.pitch = 1;      // Pitch: 0 to 2
    speechSynthesis.speak(utterance);
  };

  return (
    <Container fluid className="p-3">
      <Card className="mb-4 p-3">

        {<Row className="mb-3">


          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Standard
              </InputGroup.Text>
              <select
                className="form-select"
                name="std_id"
                value={headerData.std_id}
                disabled={!isEditable}
              onChange={(e) => handleHeaderChange(e)}
              >
                <option value="">-- Select Standard--</option>
                 {ddlAllStandards.map(std => (
                  <option key={std.std_id} value={std.std_id}>{std.std_name}</option>
                ))}

              </select>
            </InputGroup>
          </Col>

          <Col md={4}>
            <InputGroup>
              <InputGroup.Text style={{ width: "90px" }}>
                Year 1 <span style={{ color: "red" }}>*</span>
              </InputGroup.Text>
              <input
                type="number"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year1"
                value={headerData.year1}
                disabled={!isEditable}
              // onChange={handleChange}
              />&nbsp;
              <input
                type="number"
                style={{ textAlign: 'right' }}
                className="form-control"
                name="year2"
                value={headerData.year2}
                disabled={!isEditable}
              // onChange={handleChange}
              />
            </InputGroup>
          </Col>

        </Row>}


        <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap">

          <button
            type="button"
            className="btn btn-primary"
            style={{ width: "135px" }}
            onClick={handleNew}
            disabled={isEditable}
          >New
          </button>

          <button
            type="button"
            className="btn btn-secondary"
            style={{ width: "135px" }}
            onClick={handleClear}
          > Clear
          </button>

          <button
            type="button"
            className="btn btn-success"
            style={{ width: "135px" }}
            onClick={handleSave}
            disabled={!isEditable}
          > Save
          </button>
        </div>
      </Card>

      {/* Child Table */}

      <Card className="p-3">
        <div style={{ minHeight: '220px' }} className="table-wrapper">
          <table style={{ maxHeight: '35px' }} className="responsive-table-parking scty-custom-table hover-table-rcpt">
            <thead>
              <tr>
                <th style={{ width: '5%', textAlign: 'center' }}>#</th>
                <th style={{ width: '20%', textAlign: 'left' }}>Subject</th>
                <th style={{ width: '10%', textAlign: 'left' }}>Subject Type</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Subject Order</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Unit Oral/<br />Pract Max</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Unit <br />Written Pass</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Unit <br />Written Max</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Semester <br />Written Pass</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Semester <br /> Written Max</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Subject Group</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Subject <br />Group Name</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Average<br /> Subject Group</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Average Subject<br /> Group Name</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Semester II<br /> Oral Max</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Semester II <br />Written Pass</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Semester II <br />Written Max</th>
                <th style={{ width: '5%', textAlign: 'left' }}>Appl.<br /> Final</th>
                <th style={{ width: '8%', textAlign: 'right' }}>Average</th>
                <th style={{ width: '7%', textAlign: 'left' }}></th>
              </tr>
            </thead>

            <tbody>
              {childRows.map((row, index) => (
                <tr key={index}>
                  <td style={{ width: "5%", textAlign: 'center' }}>{index + 1}</td>
                  <td>
                    <select className="form-select" disabled={!isEditable}
                      name="sub_id" value={row.sub_id} onChange={(e) => handleChildChange(index, e)}>
                      <option value="0">Select Subject </option>
                      {ddlSubjects.map(sub => (
                  <option key={sub.sub_id} value={sub.sub_id}>{sub.sub_desc}</option>
                ))}
                    </select>
                  </td>
                  <td>
                    <input style={{ textAlign: 'left' }} disabled={!isEditable}
                      type="text" className="form-control" name="sub_type_id" value={row.sub_type_id} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="sub_order" value={row.sub_order} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="unit_oral_write_combo" value={row.unit_oral_write_combo} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="unit_write_pass" value={row.unit_write_pass} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="unit_write_max" value={row.unit_write_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="semester_write_pass" value={row.semester_write_pass} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="semester_write_max" value={row.semester_write_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="subject_group" value={row.subject_group} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="subject_group_name" value={row.subject_group_name} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="avg_subj_grp" value={row.avg_subj_grp} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="avg_subj_grp_name" value={row.avg_subj_grp_name} onChange={(e) => handleChildChange(index, e)} />
                  </td>

                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="semester_II_oral_max" value={row.semester_II_oral_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                    type="number" className="form-control" name="semester_II_write_pass" value={row.semester_II_write_pass} onChange={(e) => handleChildChange(index, e)} />
                   </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="semester_II_write_max" value={row.semester_II_write_max} onChange={(e) => handleChildChange(index, e)} />
                  </td>
                  <td style={{ textAlign: 'center' }}>
                    <input
                      type="checkbox"
                      className="form-check-input"
                      name="appl_final_semester"
                      checked={row.appl_final_semester === 1 || row.appl_final_semester === true}
                      disabled={!isEditable}
                      onChange={(e) =>
                        handleChildChange(index, {
                          target: {
                            name: "appl_final_semester",
                            value: e.target.checked ? 1 : 0
                          }
                        })
                      }
                    />
                  </td>
                  <td>
                    <input style={{ textAlign: 'right' }} disabled={!isEditable}
                      type="number" className="form-control" name="avg_subj_grp_name" value={row.avg_subj_grp_name} onChange={(e) => handleChildChange(index, e)} />
                  </td>


                  <td style={{ textAlign: 'center' }}>
                    {childRows.length > 1 && (
                      <Button variant="danger" onClick={() => removeRow(index)} size="sm">Delete</Button>
                    )}
                  </td>

                </tr>
              ))}
            </tbody>
          </table>
        </div>

        <div className="mb-3">
          <Button disabled={!isEditable} style={{ marginTop: '10px' }} variant="primary" onClick={addRow}>Add Row</Button>
        </div>
      </Card>

      {/* Buttons */}
    </Container>
  );
};

export default Mand_Classwise_Sub;
